//Experience
document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.classList.contains('template-index')) return;
    new Swiper(".accessory-swiper .swiper", {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 300,
        loop: false,
        loopAdditionalSlides: 0,
        loopedSlides: 0,
        loopFillGroupWithBlank: false,
        freeMode: true,
        mousewheel: {
            forceToAxis: true, // only horizontal scroll will work
        },
        navigation: {
            nextEl: ".accessory-swiper .swiper-button-next",
            prevEl: ".accessory-swiper .swiper-button-prev"
        },
        scrollbar: {
            el: '.accessory-swiper .swiper-scrollbar',
            draggable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 'auto',
            }
        }
    });

    // modal-carousel
    const swiperSelectors = document.querySelectorAll('.modal-carousel');
    const swiperInstances = new Map();
    
    function initSwipers() {
        swiperSelectors.forEach((carousel, index) => {
            const swiperEl = carousel.querySelector('.swiper');
    
            if (window.innerWidth >= 768 && !swiperInstances.has(swiperEl)) {
                const swiper = new Swiper(swiperEl, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    speed: 800,
                    freeMode: true,
                    mousewheel: {
                        forceToAxis: true,
                    },
                    navigation: {
                        nextEl: carousel.querySelector('.swiper-button-next'),
                        prevEl: carousel.querySelector('.swiper-button-prev')
                    },
                    scrollbar: {
                        el: carousel.querySelector('.swiper-scrollbar'),
                        draggable: true,
                    }
                });
    
                swiperInstances.set(swiperEl, swiper);
            } else if (window.innerWidth < 768 && swiperInstances.has(swiperEl)) {
                swiperInstances.get(swiperEl).destroy(true, true);
                swiperInstances.delete(swiperEl);
            }
        });
    }
    
    // Run on load
    initSwipers();
    
    // Re-run on resize
    window.addEventListener('resize', initSwipers);


});

$('.accessory-card').on('click', function () {
    var _id = $(this).attr('data-modal-target');
    var $modal = $('[data-modal-handle="' + _id + '"]');

    $modal.addClass('open');
    document.body.style.overflow = 'hidden';

    // Wait for modal to render before scrolling
    setTimeout(function () {
        $modal.find('.modal-content')[0].scrollTop = 0;
    }, 10); // 10ms delay is usually enough

    $('.section-header').css({
        'top': '-90px'
    });
});


$('.accessory-modal .modal-close').on('click', function () {
    $(this).parents('.modal-template').removeClass('open');
    document.body.style.overflow = '';
})


document.addEventListener("DOMContentLoaded", function () {
    const tabGroups = document.querySelectorAll(".modal-tabs");

    tabGroups.forEach(group => {
        const tabs = group.querySelectorAll(".tab");

        // Create and append the line
        const line = document.createElement("div");
        line.classList.add("tab-line");
        group.appendChild(line);

        function updateLine() {
            const activeTab = group.querySelector(".tab.active");
            if (activeTab) {
                const { offsetLeft, offsetWidth } = activeTab;
                line.style.left = `${offsetLeft}px`;
                line.style.width = `${offsetWidth}px`;
            }
        }

        tabs.forEach(tab => {
            tab.addEventListener("click", e => {
                e.preventDefault();
                tabs.forEach(t => t.classList.remove("active"));
                tab.classList.add("active");
                updateLine();
            });
        });

        window.addEventListener("resize", updateLine);
        updateLine();
    });
});


$('.modal-tabs .tab').on('click', function () {
    var _id = $(this).attr('data-tab');
    $(this).parents('.modal-container').find('.modal-tab-content').removeClass('active');
    $(_id).addClass('active');
})

//Auto Slider Start

  let userInteractedWithFirstOption = false;

  document.querySelectorAll('fieldset.input-fieldset').forEach((fieldset, index) => {
    if (index === 0) { // Only the first option group
      fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
        input.addEventListener('change', () => {
          userInteractedWithFirstOption = true;
        });
      });
    }
  });
  


  function callSlider(gallery,media){
    console.log("GALLERY",gallery);
    console.log("MEDIA",media);
    const mediaId = media.dataset.media;
    if (mediaId) {
      //
      const index = getSlideIndexByMedia(mediaId);
      if (index >= 0) {
       let callDelay = 0;
          if (userInteractedWithFirstOption) {
         callDelay = 1000;
        $('html, body').animate({ scrollTop: '0px' }, 1000);
        userInteractedWithFirstOption = false; // Reset after scroll
      }
         setTimeout(function(){$('.product-gallery__media-list1').slick('slickGoTo', index)},callDelay);
        console.log('Jumped to slick slide index:', index);
      } else {
        console.warn(`No slide found for data-media="${mediaId}"`);
      }
    }
  }

  function getSlideIndexByMedia(mediaValue) {
    const slides = document.querySelectorAll('.product-gallery__media-list1 .slick-slide:not(.slick-cloned)');
    return Array.from(slides).findIndex(slide => {
      const mediaDiv = slide.querySelector('[data-media]');
      return mediaDiv && mediaDiv.dataset.media === mediaValue;
    });
  }

  //Auto Slider End


//COLLECTION DOM FIX Start
function bindDisclosureObservers() {
  document.querySelectorAll('.disclosure__toggle').forEach((toggleEl) => {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
          const isExpanded = toggleEl.getAttribute('aria-expanded');
          if(isExpanded === "true"){
                              $("#common-overlay").addClass("show");
                            }else{
                               $("#common-overlay").removeClass("show");
                            }
          console.log('Disclosure toggled:', isExpanded, toggleEl);
        }
      }
    });

    observer.observe(toggleEl, { attributes: true });

    // Optional: store the observer if you want to disconnect later
    toggleEl._ariaObserver = observer;
  });
}

// Initial bind
bindDisclosureObservers();


$(document).on("click",".disclosure__link",function(){
  console.log($(this).attr("class"));
  //if(!$(this).hasClass("disclosure__link--selected")){
    console.log("FILTER SELECTED");
    $(".disclosure__toggle").hide();
    var newbutton = '<span class="newtogglebutton" type="button">Loading...</span>';
    $(".disclosure__wrapper").first().append(newbutton);
  //}
});




// Watch for new disclosure__toggle elements being added
const parentContainer = document.body; // or a more specific container like '.facets' or '.collection-filters'

const domWatcher = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1 && node.matches('.disclosure__toggle')) {
        // Re-bind to the new toggle button
        bindDisclosureObservers();
      } else if (node.nodeType === 1 && node.querySelector('.disclosure__toggle')) {
        // Re-bind if new HTML block contains a disclosure toggle
        bindDisclosureObservers();
      }
    });
  }
});

domWatcher.observe(parentContainer, { childList: true, subtree: true });


$(document).ready(function () {
  const $navDetails = $("details[data-nav-desktop-details]");

  // Handle toggle (click-based opening/closing)
  $navDetails.on("toggle", function () {
    if ($(this).is("[open]")) {
      $("body").addClass("no-scroll");
    } else {
      $("body").removeClass("no-scroll");
    }
  });

  // Optional: Handle hover open/close
  $navDetails.hover(
    function () {
      $(this).attr("open", true);
      $("body").addClass("no-scroll");
    },
    function () {
      $(this).removeAttr("open");
      $("body").removeClass("no-scroll");
    }
  );
});

//COLLECTION DOM FIX END


//OFFER BAR CODE
$(document).ready(function () {
  function initAnnouncement(containerSelector) {
    var $items = $(containerSelector + " .announcement-bar");
    if ($items.length === 0) return;  // nothing to animate

    var index = 0;
    var intervalTime = 4000;
    var interval;

    function flipBar(){
      $items.toggleClass("flip");
    }

    function startRotation() {
      interval = setInterval(function () {
        flipBar();
      }, intervalTime);
    }

    function stopRotation() {
      clearInterval(interval);
    }

    startRotation();

    $items.on("mouseenter", stopRotation);
    $items.on("mouseleave", startRotation);
  }

  // Detect which version to run
  if (window.matchMedia("(min-width: 720px)").matches) {
    initAnnouncement(".ann-wrapper_desktop");
  } else {
    initAnnouncement(".ann-wrapper_mobile");
  }
});

// revised UI modification of header section on scroll
window.addEventListener("DOMContentLoaded", (event) => {
  let prevscroll = 0,
  setTimeoutId;
  let header = document.querySelector(".shopify-section.section-header");
  var activeClass = "";
  if ($('.ann-wrapper_desktop').css('display') === 'block') {
      activeClass = 'ann-wrapper_desktop';
  } else if ($('.ann-wrapper_mobile').css('display') === 'block') {
      activeClass = 'ann-wrapper_mobile';
  }
  let bar = null;
  if(activeClass != ''){
    bar = document.querySelector("."+activeClass);
  }

  let barHeight = bar ? bar.offsetHeight : 0;
  let extraOffset = 90;
  let custom_message_field = document.querySelector(".custom_message_field") ? document.querySelector(".custom_message_field").offsetHeight : 0;
  let hideOffset = "-"+(barHeight + extraOffset + custom_message_field)+"px";
  //let hideOffset = "-"+(barHeight + extraOffset)+"px";
  let scrollposition = barHeight + 70;

  // let header_toolbar  =  document.querySelector(".header-toolbar__content");
  // let toolbar_height  =  header_toolbar ? header_toolbar.offsetHeight : 0;
  // console.log(toolbar_height);
  // if(toolbar_height < 5){
  //   header_toolbar.style.display = "none"
  // }else{
  //   header_toolbar.style.display = "flex"
  // }


  window.addEventListener("scroll", (e) => {
    //console.log("this code");
    const isbanner = window.location.pathname == "/";
    const isBannerVisible = window.scrollY > scrollposition;
    if (prevscroll > window.scrollY) {
      header.style.top = "0px";
    } else if (prevscroll < window.scrollY && window.scrollY > 100) {
      //console.log("-${hideOffset}px");
      header.style.top = isBannerVisible ? hideOffset : '0px';
    }
    setTimeoutId = setTimeout(() => {
      prevscroll = window.scrollY;
    }, 100);
  });
});

//OFFER CODE END